import React from 'react';
import {connect} from 'react-redux';
import {AjaxSpinner, Button, ChildPosition, PopOver, PopupWindow, Size, TextInput} from '@utahdts/dts-react-common';
import PopOverTypes from '@utahdts/dts-react-common/components/pop-over/popOverTypes';
import {iconMenu, iconSearch, iconUser} from "../common/Icon";
import Breadcrumb from "./breadcrumb";
import MainMenu from "./main-menu";
import Media from "react-media";
import {dispatchUpdateData, formatCobiYear, isAllowed, MEDIA_SIZES} from "../misc/Shared";
import userManager from "../app/UserManager";
import {Link, withRouter} from 'react-router-dom';
import {isEmpty} from "lodash";

const mapStateToProps = (state) => {
	return {
		admin: state.app.admin,
		currentCobiId: state.app.currentCobiId,
		currentTab: state.app.currentTab,
		currentYear: state.app.currentYear,
		userAccount: state.userAccount,
		user: state.user,
	};
};

class Header extends React.Component {
	constructor(props) {
		super(props);

		this.toggleMenu = this.toggleMenu.bind(this);
		this.toggleSearch = this.toggleSearch.bind(this);
		this.triggerSearch = this.triggerSearch.bind(this);
		this.signOut = this.signOut.bind(this);

		this.state = {
			menuIsOpen: false,
			searchIsOpen: false,
			searchValue: '',
			signingOut: false,
		};
	}

	toggleMenu() {
		const newMenuState = !this.state.menuIsOpen;
		this.setState({menuIsOpen: newMenuState});
	}

	toggleSearch() {
		const newSearchState = !this.state.searchIsOpen;
		this.setState({searchIsOpen: newSearchState, searchValue: ''});
	}

	triggerSearch() {
		window.open(`https://le.utah.gov/solrsearch.jsp?request=${encodeURIComponent(this.state.searchValue)}&stype=COBI`,'_blank');
	}

	checkUser() {
		return !isEmpty(this.props.user) && !this.props.user.expired;
	}

	signOut() {
		userManager.signoutRedirect().then(() => {
			setTimeout(() => {
				let payload = [
					{
						field: 'user',
						value: {}
					},
					{
						field: 'userAccount',
						value: {
							utahId: undefined,
							userId: undefined,
							firstName: undefined,
							lastName: undefined,
							fullName: undefined,
							email: undefined,
							roleName: undefined,
							active: undefined,
						}
					},
					{
						path: 'app',
						field: 'admin',
						value: false
					}
				];
				if(window.location.pathname.includes('admin')) {
					payload.push({
						path: 'app',
						field: 'currentPageTitle',
						value: `COBI ${formatCobiYear(this.props.currentYear)}`
					});
				}
				dispatchUpdateData(payload);
				this.setState({signingOut: false});
			}, 2000);
		});
	}

	render() {
		return (
			<header className="main-header">
				{this.state.signingOut && <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/>}
				{this.state.menuIsOpen && <MainMenu menuClose={this.toggleMenu} history={this.props.history}/>}
				<div className="main-header__navigation flex align-start">
					<Button
						children={<div className="icon-tab">{iconMenu('hcenter vcenter')}</div>}
						childrenPosition={Button.CHILDREN_POSITION.BEFORE}
						className="navigate-button button--solid button--tab-icon no-print"
						label="Navigate"
						onClick={this.toggleMenu}
					/>
					<Media query={MEDIA_SIZES.TABLET_NARROW_MIN_WIDTH} render={() => (
						<React.Fragment>
							<span className="breadcrumb-triangle"/>
							<Breadcrumb/>
						</React.Fragment>
					)}/>
					{this.state.searchIsOpen && <PopupWindow
						onCloseButtonCallback={this.toggleSearch}
						onEnterKeyPressed={this.triggerSearch}
						className="popup-window--large popup-window--search">
							<div className="content search_content">
								<TextInput
								label="Search"
								showLabel={false}
								children={iconSearch()}
								childrenPosition={ChildPosition.BEFORE}
								field="searchValue"
								placeholder={window.innerWidth > 500 ? "Enter your search term..." : "Search..."}
								value={this.state.searchValue}
								className="atid_text_input_search search_input"
								size={Size.FULL_WIDTH}
								onChange={(field, value) => this.setState({[field]: value})}
								setInitialFocus={true}
							/>
							<Button
								label="Search"
								onClick={this.triggerSearch}/>
						</div>
					</PopupWindow>}
					<Button
						children={<div className="icon-tab">{iconSearch('hcenter vcenter')}</div>}
						childrenPosition={Button.CHILDREN_POSITION.BEFORE}
						className="search-button button--solid button--tab-icon no-print"
						label="Search COBI"
						onClick={this.toggleSearch}
					/>
					<Media query={MEDIA_SIZES.TABLET_NARROW_MIN_WIDTH} render={() => (
						this.checkUser() ?
							<PopOver
								anchor={(
									<>
										<div className="icon-tab">{iconUser('hcenter vcenter')}</div>
										<span className="button-label no-print">
											{this.props.userAccount.firstName ? `Welcome, ${this.props.userAccount.firstName}` : 'Welcome, user'}
										</span>
									</>
								)}
								classNameAnchor="popover__anchor button--solid button--tab-icon no-print user-button"
								dismissible={true}
								focusable={true}
								position={PopOver.POSITION.BOTTOM}
								popOverType={PopOverTypes.LISTBOX}
							>
								<ul className="sub-menu">
									{this.props.admin ? undefined : isAllowed() && <li><Link to={`/admin/editor/${this.props.currentYear}/${this.props.currentCobiId}/${this.props.currentTab}`}>Edit page</Link></li>}
									{this.props.admin && !location.pathname.includes('landing') && isAllowed() ? <li><Link to={`/${this.props.currentYear}/${this.props.currentCobiId}/${this.props.currentTab}`}>View page</Link></li> : undefined}
									{isAllowed() && <li><Link to={`/admin/landing`}>My List</Link></li>}
									<li onClick={() => this.setState({signingOut: true}, this.signOut)}>Sign out</li>
								</ul>
							</PopOver>
							: <Button
								children={<div className="icon-tab">{iconUser('hcenter vcenter')}</div>}
								childrenPosition={Button.CHILDREN_POSITION.BEFORE}
								className="user-button button--solid button--tab-icon no-print"
								label="Sign in"
								onClick={() => userManager.signinRedirect()}
							/>
					)}/>
					<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH} render={() => (
						<div className="cobi-year-text flex1"><span>COBI </span>{formatCobiYear(this.props.currentYear)}</div>
					)}/>
				</div>
				{this.state.menuIsOpen && <div className="main-header__backdrop"/>}
			</header>
		);
	}
}

export default withRouter(connect(mapStateToProps)(Header));
